export interface FileAttachment {
    file: File | Blob;
    path: string;
    name?: string;
    type?: string;
}

export interface AttachmentObj {
    attachment: FileAttachment;
    documentid: number;
    userid: string;
    chargerid: string;
    checksum: string; // Changed from number to string for SHA-256 hash
    documentname: string;
    size: number;
    identifier: string;
    revisionid: number;
    fileversion: number;
    uploadedby: string;
}

// File type categories for validation
export enum FileTypeCategory {
    IMAGE = 'image',
    DOCUMENT = 'document',
    PDF = 'pdf',
    VIDEO = 'video',
    AUDIO = 'audio',
    ANY = 'any'
}

// MIME type mappings for validation
export const ALLOWED_MIME_TYPES: Record<FileTypeCategory, string[]> = {
    [FileTypeCategory.IMAGE]: [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'image/webp',
        'image/svg+xml'
    ],
    [FileTypeCategory.DOCUMENT]: [
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/plain',
        'text/csv'
    ],
    [FileTypeCategory.PDF]: [
        'application/pdf'
    ],
    [FileTypeCategory.VIDEO]: [
        'video/mp4',
        'video/mpeg',
        'video/quicktime',
        'video/x-msvideo',
        'video/webm'
    ],
    [FileTypeCategory.AUDIO]: [
        'audio/mpeg',
        'audio/mp4',
        'audio/wav',
        'audio/webm'
    ],
    [FileTypeCategory.ANY]: [] // Empty array means allow all
};

// File validation options
export interface FileValidationOptions {
    maxSizeBytes?: number; // Default: 10MB
    allowedTypes?: FileTypeCategory;
    customMimeTypes?: string[];
}

// Default validation settings
export const DEFAULT_MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB default

// File validation result
export interface FileValidationResult {
    isValid: boolean;
    error?: string;
}

export const createEmptyAttachmentObj = (overrides?: Partial<AttachmentObj>): AttachmentObj => ({
    attachment: {
        file: new Blob(),
        path: '',
        name: '',
        type: ''
    },
    documentid: 0,
    userid: '',
    chargerid: '',
    checksum: '',
    documentname: '',
    size: 0,
    identifier: '',
    revisionid: 0,
    fileversion: 0,
    uploadedby: '',
    ...overrides
})

const fileActions = {
    // Upload actions
    "UPLOAD_FILE": 0,
    "ATTACH_TO_USER_ID": 1,
    "ATTACH_TO_CHARGER_ID": 2,

    //Download Actions
    "DOWNLOAD_FILE": 100,

    // Handler Actions
    "DELETE_FILE_OLD": 200,
    "DELETE_ASSOCIATION": 201,
    "RESTORE_FILE": 201,
    "RETRIEVE_FILE_VERSION": 202,
    "RENAME_FILE": 203,

    // Versioning
    "GET_FILE_VERSION": 301,
    "RETRIEVE_MAX_FILE_VERSION": 302,

    // File Lists
    "LIST_OF_ALL_FILES": 400,
    "LIST_OF_FILES_BY_USERID": 401,
    "LIST_OF_FILES_BY_NAME": 402,
    "LIST_ALL_VERSIONS": 403
} 

export {fileActions}